import Vue from "vue";
import { Component, Prop, PropSync } from "vue-property-decorator";

@Component
export default class CustomDialog extends Vue {
    @Prop({ type: String, default: "" })
    readonly title!: string;

    @PropSync("showDialog", { type: Boolean, default: false })
    dialogModel!: boolean;

    @Prop({ type: [Number, String], default: 1500 })
    readonly maxWidth!: number | string;

    @Prop({ type: Boolean, default: true })
    readonly persistent!: boolean;

    get hasSaveListener(): boolean {
        return !!this.$listeners.save;
    }

    saveClick() {
        this.$emit("save");
    }

    cancelClick() {
        this.$emit("cancel");
    }
}